export default class CodeVerifierHelper {
  static generateRandomString() {
    var array = new Uint32Array(56/2);
    window.crypto.getRandomValues(array);
    return Array.from(array, this.dec2hex).join('');
  }

  static async challengeFromVerifier(v) {
    const hashed = await this.sha256(v);
    const base64encoded = this.base64urlencode(hashed);
    return base64encoded;
  }

  static dec2hex(dec) {
    return ('0' + dec.toString(16)).substr(-2)
  }

  static sha256(plain) { // returns promise ArrayBuffer
    const encoder = new TextEncoder();
    const data = encoder.encode(plain);
    return window.crypto.subtle.digest('SHA-256', data);
  }

  static base64urlencode(a) {
    let str = "";
    const bytes = new Uint8Array(a);
    const len = bytes.byteLength;
    for (var i = 0; i < len; i++) {
      str += String.fromCharCode(bytes[i]);
    }
    return btoa(str)
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=+$/, "");
  }
}
 
